import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import CourseFinder from './course-finder/CourseFinder.jsx'
import { initializeAnalytics } from './course-finder/analytics.js'
import './course-finder/styles.css'

initializeAnalytics()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <CourseFinder />
  </StrictMode>,
)
